// Pure constants only — the Electron main process imports this module.
export const AMBOSS_DOMAIN = 'amboss.com';
export const AMBOSS_EMBED_HOST = 'next.amboss.com';
export const AMBOSS_ORIGINS: readonly string[] = [
  'https://amboss.com',
  'https://next.amboss.com',
  'https://www.amboss.com',
];
export const MICROSOFT_AUTH_DOMAINS: readonly string[] = [
  'microsoftonline.com',
  'microsoftazuread-sso.com',
];
export const ENTRA_SSO_COOKIE_HOSTS: readonly string[] = [
  'login.microsoftonline.com',
  'autologon.microsoftazuread-sso.com',
];

export function matchesDomain(hostname: string, domain: string): boolean {
  return hostname === domain || hostname.endsWith(`.${domain}`);
}
